<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-06-15 22:24:02
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-16 10:25:10
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/chart-area.vue
 * @Description: 面积图
-->
<template>
  <div id="chart-area" v-loading="loading.ccy"></div>
</template>

<script>
import { Chart } from '@antv/g2'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      chart: null
    }
  },
  computed: {
    ...mapState('company-profile', ['ccy', 'loading'])
  },
  watch: {
    'loading.ccy' () {
      this.initChart()
    }
  },
  methods: {
    initChart () {
      this.chart = new Chart({
        container: 'chart-area',
        autoFit: true
      })
      this.chart.data(this.ccy.sc_trend)
      this.chart.scale('value', {
        min: 0, max: 12000, alias: '产值(万元)'
      })
      this.chart.scale('total', {
        min: 0, max: 12000, alias: '产业总值(万元)'
      })
      this.chart.axis('total', false)
      this.chart.axis('value', {
        position: 'left',
        tickCount: 5,
        label: {
          style: {
            fill: '#FFFFFF'
          }
        },
        grid: {
          line: {
            style: {
              stroke: '#d9d9d9',
              lineWidth: 1,
              lineDash: [1, 1]
            }
          }
        },
        title: {
          text: '产值(万元)',
          autoRotate: true,
          position: 'center',
          style: {
            fill: '#FFFFFF'
          }
        }
      })
      this.chart.axis('year', {
        position: 'bottom',
        label: {
          style: {
            fill: '#FFFFFF'
          }
        }
      })
      this.chart.legend({
        position: 'top',
        itemName: {
          style: {
            fill: '#FFFFFF'
          }
        }
      })

      this.chart.area()
        .adjust('stack')
        .position('year*value')
        .color('name', ['#E47B6A', '#F5C41B', '#10F5B1'])
        .style({
          stroke: null
        })
      this.chart.line()
        .adjust('stack')
        .position('year*value')
        .color('name', ['#E47B6A', '#F5C41B', '#10F5B1'])

      this.chart.line()
        .position('year*total')
        .color('#6DF9FF')
      this.chart.annotation().dataMarker({
        top: true,
        position: ['2020', 10800],
        line: {
          length: 10
        },
        text: {
          content: '历年产业总值趋势',
          style: {
            textAlign: 'center',
            fill: '#ffffff'
          }
        }
      })
      this.chart.render()
    }
  }
}
</script>
